import Axios, { InternalAxiosRequestConfig } from "axios";

const axiosClient = Axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "",
});

// Add a request interceptor to get the latest values from sessionStorage for each request
axiosClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    let lang = sessionStorage.getItem("mylmx-lang");
    const logicChannel = sessionStorage.getItem("mylmx-logic");

    if (logicChannel === "swiss") {
      lang = lang === "fr" ? "fr" : "ch";
    }

    // Set headers using type-safe approach
    config.headers.set("Accept-Language", lang || "");
    config.headers.set("Logic-Channel", logicChannel || "");

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosClient;
